import * as React from 'react';

import { AndroidStoreLink, AppleStoreLink } from '@origin-digital/ods-lab';

import {
  AppPromoContainer,
  ButtonContainer,
  ImageContainer,
  TextContainer,
} from './AppPromo.styles';
import { Awards } from '../Common/Awards';
import { getCloudinaryUrl } from '../../services/cloudinary';
import { Heading2, Heading3 } from '../Text';
import { IDigitalAdoption } from '../../../src/models/content.interfaces';
import { isAppleMobile, isAndroid } from '../../utils/utils';

export const AppPromo = ({
  appleLink,
  androidLink,
  headline,
  byline,
  imageSHA,
}: IDigitalAdoption) => {
  const UA = window.navigator.userAgent;
  return (
    <AppPromoContainer data-id="digital-adoption">
      <ImageContainer data-id="app-promo-image" backgroundImage={getCloudinaryUrl(imageSHA)} />
      <TextContainer>
        <Heading2>{headline}</Heading2>
        <Heading3 data-id="app-promo-text">{byline}</Heading3>
        <ButtonContainer>
          {!isAndroid(UA) && (
            <AppleStoreLink
              data-id="app-promo-app-store"
              componentType="link"
              href={appleLink}
              target="_blank"
            />
          )}
          {!isAppleMobile(UA) && (
            <AndroidStoreLink
              data-id="app-promo-google-play"
              componentType="link"
              href={androidLink}
              target="_blank"
            />
          )}
        </ButtonContainer>
        <Awards data-id="awards" />
      </TextContainer>
    </AppPromoContainer>
  );
};
